var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPinFilled = function SvgPinFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    viewBox: "0 0 18 18",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.484 16.362a1.94 1.94 0 0 1-1.21-.4 49 49 0 0 1-3.86-3.363l-5.13 5.103a.74.74 0 0 1-.53.26.7.7 0 0 1-.53-.22.74.74 0 0 1 0-1.06l5.105-5.168a49 49 0 0 1-3.365-3.862 1.93 1.93 0 0 1-.33-1.78 2 2 0 0 1 1.33-1.34l4-1.34 4.21-2.82a2.26 2.26 0 0 1 2.84.29l3.25 3.21a2.26 2.26 0 0 1 .29 2.84l-2.82 4.25-1.34 4a2 2 0 0 1-1.34 1.3 2.2 2.2 0 0 1-.57.1",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPinFilled);
export default ForwardRef;